import { apiClient } from "../config";

async function addCommunityMember(id: any, data: any) {
  const res = await apiClient.post(`/admin/communities/${id}/member`, data);
  return res.data;
}

export default addCommunityMember;
